import { Box } from "@mui/material";
import CommonButtons from "src/shared/components/CommonButtons";

interface EditProductActionsProps {
  onClose: () => void;
  onUpdate: () => void;
  isUpdateEnabled: boolean;
}

const EditProductActions: React.FC<EditProductActionsProps> = ({ onClose, onUpdate, isUpdateEnabled }) => (
  <Box display="flex" justifyContent="flex-end" gap={2} mt={4}>
    <CommonButtons label="Cancel" className="w-32 h-10" variant="outlineDanger" onClick={onClose} />
    <CommonButtons label="Update" className="w-32 h-10" variant="primary" onClick={onUpdate} disabled={!isUpdateEnabled} />
  </Box>
);

export default EditProductActions;
